import * as types from '../../constants/app/devImageUploadConstants';

export const uploadedImageListRequest = ({
  page,
  pageLength,
  filePath,
  callback,
  error,
}) => ({
  type: types.UPLOADED_IMAGE_LIST_REQUEST,
  page,
  pageLength,
  filePath,
  callback,
  error,
});
